import React, { useEffect, useState } from 'react';
import { StatusBar as StatusBarBase } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Animated, { interpolateColor, useAnimatedStyle, withTiming, } from 'react-native-reanimated';
import { create } from 'zustand';
import { ThemeMode } from '@annunciate/core';
import { useTheme, useColorScheme, } from '../../hooks';
export var StatusBarMode;
(function (StatusBarMode) {
    StatusBarMode[StatusBarMode["DARK"] = 0] = "DARK";
    StatusBarMode[StatusBarMode["DEFAULT"] = 1] = "DEFAULT";
    StatusBarMode[StatusBarMode["HIDDEN"] = 2] = "HIDDEN";
})(StatusBarMode || (StatusBarMode = {}));
export const useStatusBarModeStore = create()((set) => ({
    mode: StatusBarMode.DEFAULT,
    setMode: (mode) => set(() => ({
        mode,
    })),
}));
export const StatusBar = () => {
    const colorScheme = useColorScheme();
    const { colors: { backgroundPrimary } } = useTheme();
    const mode = useStatusBarModeStore((state) => state.mode);
    const [backgroundColor, setBackgroundColor] = useState({
        previous: backgroundPrimary,
        next: backgroundPrimary,
    });
    const backgroundColorStyle = useAnimatedStyle(() => {
        const i = interpolateColor(1, [0, 1], [
            backgroundColor.previous,
            backgroundColor.next,
        ]);
        return {
            backgroundColor: withTiming(i, { duration: 175 }),
        };
    }, [
        backgroundColor.previous,
        backgroundColor.next,
    ]);
    useEffect(() => {
        const statusBarStyle = colorScheme === ThemeMode.DARK
            ? 'light-content'
            : 'dark-content';
        const standardBackgroundColor = backgroundPrimary;
        if (mode === StatusBarMode.HIDDEN) {
            StatusBarBase.setHidden(true, 'fade');
            setBackgroundColor(({ next }) => {
                return { previous: next, next: '#000000' };
            });
        }
        else if (mode === StatusBarMode.DARK) {
            StatusBarBase.setBarStyle('light-content');
            setBackgroundColor(({ next }) => {
                return { previous: next, next: '#000000' };
            });
            StatusBarBase.setHidden(false, 'fade');
        }
        else {
            StatusBarBase.setBarStyle(statusBarStyle);
            setBackgroundColor(({ next }) => {
                return { previous: next, next: standardBackgroundColor };
            });
            StatusBarBase.setHidden(false, 'fade');
        }
    }, [mode, colorScheme, backgroundPrimary]);
    const { top } = useSafeAreaInsets();
    return (React.createElement(Animated.View, { style: [
            { height: top },
            backgroundColorStyle,
        ] },
        React.createElement(StatusBarBase, { translucent: true, backgroundColor: 'transparent' })));
};
//# sourceMappingURL=StatusBar.js.map